<div class="team-grid">
  <app-page-data-panel title="Manager summary" subtitle="At-a-glance visibility into the team you currently manage.">
    <div class="team-summary">
      <div><span>Team size</span><strong>{{ summary?.teamSize || 0 }}</strong></div>
      <div><span>Pending leave</span><strong>{{ summary?.pendingLeaveRequests || 0 }}</strong></div>
      <div><span>Submitted timesheets</span><strong>{{ summary?.submittedTimesheets || 0 }}</strong></div>
      <div><span>Open learning</span><strong>{{ summary?.openLearningAssignments || 0 }}</strong></div>
    </div>
  </app-page-data-panel>

  <app-page-data-panel
    title="Direct reports"
    subtitle="Minimal list of employees currently reporting to you."
    [resultText]="(summary?.directReports?.length || 0) + ' employees'">
    @if (summary?.directReports?.length) {
      <p-table [value]="summary?.directReports || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Employee</th>
            <th>Department</th>
            <th>Job</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-employee>
          <tr>
            <td>
              <span class="p-column-title">Employee</span>
              <strong>{{ employee.displayName || employee.firstName }}</strong>
              <div class="table-subtitle">{{ employee.employeeNumber || '-' }}</div>
            </td>
            <td><span class="p-column-title">Department</span>{{ employee.departmentName || '-' }}</td>
            <td><span class="p-column-title">Job</span>{{ employee.jobName || '-' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(employee.status)" [severity]="statusSeverity(employee.status)"></p-tag></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No direct reports are assigned yet.</p>
    }
  </app-page-data-panel>
</div>
